import { INTENT, STATE, on, dispatch } from "./ui-events.js";

const SELECTORS = {
  input: "[data-sd-input]",
};

class SearchDrawer extends HTMLElement {
  #callbackFunctions = [];

  constructor() {
    super();
    this.onKeydown = this.onKeydown.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return;
    }

    try {
      this.init();
    } catch (error) {
      console.error("[SearchDrawer:init]", error);
    }
  }

  init() {
    this.#bindElements();
    this.#bindEvents();
  }

  #bindElements() {
    this.input = this.querySelector(SELECTORS.input);
  }

  #bindEvents() {
    document.addEventListener("keydown", this.onKeydown);
    document.addEventListener("click", this.onDocumentClick);
    this.#callbackFunctions.push(
      on(INTENT.SEARCH_OPEN, () => this.toggle()),
      on(INTENT.SEARCH_CLOSE, () => this.close()),
    );
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.dataset.state = "visible";
    this.input?.focus();
  }

  close() {
    this.dataset.state = "hidden";
    dispatch(STATE.SEARCH_CLOSED);
  }

  isOpen() {
    return this.dataset.state === "visible";
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.isOpen()) this.close();
  }

  onDocumentClick(event) {
    if (!this.isOpen()) return;
    if (event.target.closest("[data-sd-overlay]")) {
      this.close();
      return;
    }
    if (this.contains(event.target)) return;
    if (event.target.closest("open-search-drawer-button")) return;
    this.close();
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #cleanup() {
    document.removeEventListener("keydown", this.onKeydown);
    document.removeEventListener("click", this.onDocumentClick);
    this.#callbackFunctions.forEach((fn) => fn());
    this.#callbackFunctions = [];
  }
}

if (!customElements.get("search-drawer")) {
  customElements.define("search-drawer", SearchDrawer);
}
